import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, vShow as _vShow, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " チャートを作成する ", -1)
const _hoisted_3 = { class: "col-12 input-group-sm float-start" }
const _hoisted_4 = { class: "col-5 float-start" }
const _hoisted_5 = { class: "col-9 float-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-3 float-end" }, "から", -1)
const _hoisted_7 = { class: "col-5 float-start" }
const _hoisted_8 = { class: "col-9 float-start" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-3 float-end" }, "迄", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { style: {"width":"100%"} }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "チャートの種類", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "line" }, "線グラフ", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"\">集約</option><option value=\"none\">集約なし</option><option value=\"median1min\">１分間の中央値</option><option value=\"median5min\">5分間の中央値</option><option value=\"median10min\">１0分間の中央値</option>", 5)
const _hoisted_32 = [
  _hoisted_27
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { style: {"height":"700px"} }
const _hoisted_39 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
            type: "date",
            id: "start",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 512), [
            [_vModelText, _ctx.startDate]
          ])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
            t: "",
            type: "date",
            id: "end",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 512), [
            [_vModelText, _ctx.endDate]
          ])
        ]),
        _hoisted_9
      ]),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sensorId) = $event)),
            placeholder: "センサのID",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.sensorId]
          ])
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chartType) = $event)),
            class: "form-control"
          }, _hoisted_23, 512), [
            [_vModelSelect, _ctx.chartType]
          ])
        ])
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.aggregation) = $event)),
            class: "form-control"
          }, _hoisted_32, 512), [
            [_vModelSelect, _ctx.aggregation]
          ])
        ])
      ]),
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("button", {
          style: {"margin":"1%"},
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
          class: "btn btn-dark"
        }, "更新"),
        _createElementVNode("button", {
          style: {"margin":"1%"},
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getURL && _ctx.getURL(...args))),
          class: "btn btn-dark"
        }, "URLを作成")
      ])
    ]),
    _hoisted_35,
    _hoisted_36,
    _withDirectives(_createElementVNode("span", {
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.copyURL && _ctx.copyURL(...args))),
      style: {"background-color":"lightgray","padding":"1%","vertical-align":"50%","border-radius":"8px 8px 8px 8px","cursor":"pointer"}
    }, _toDisplayString(_ctx.resultSrc), 513), [
      [_vShow, _ctx.resultSrc]
    ]),
    _hoisted_37,
    _createElementVNode("section", _hoisted_38, [
      _createElementVNode("iframe", {
        id: "chartview",
        "allow-storage-access-by-user-activation": "",
        style: {"height":"100%"},
        class: "col-12",
        src: _ctx.src
      }, null, 8, _hoisted_39)
    ])
  ]))
}